export default function getAccountStatementUrl(
    customerId: string | undefined,
    year: number | undefined,
    month: number | undefined,
) {
    if (!customerId || !year || !month) return;

    return `/api/mit-fog/downloadAccountStatement?customerId=${customerId}&year=${year}&month=${month}`;
}
